import { useEffect, useState } from "react";

import { ISliderSettings } from "../Slider/Slider.component";

import {
  DEFAULT_SLIDES_TO_SHOW,
  defaultSettings,
  MAX_SLIDES_TO_SHOW,
  PREV_NEXT_WIDTH_PERCENTAGE,
} from "./settings";

const useSettings = (
  itemsCount: number,
  maxSlides?: string
): ISliderSettings => {
  const [settings, setSettings] = useState<ISliderSettings>(defaultSettings);

  useEffect(() => {
    if (maxSlides) {
      let slidesToShow = parseInt(maxSlides, 10);

      // slidesToShow should be an integer >= 4
      if (
        !Number.isInteger(slidesToShow) ||
        slidesToShow < DEFAULT_SLIDES_TO_SHOW
      ) {
        slidesToShow = DEFAULT_SLIDES_TO_SHOW;
      }

      // slidesToShow should be <= 6
      if (slidesToShow > MAX_SLIDES_TO_SHOW) {
        slidesToShow = MAX_SLIDES_TO_SHOW;
      }

      // slidesToShow should be <= items count
      if (slidesToShow > itemsCount) {
        slidesToShow = itemsCount;
      }

      setSettings((state) => ({
        ...state,
        slidesToShow,
        responsive: [
          {
            breakpoint: 1120,
            settings: {
              slidesToShow: slidesToShow - 1 > 0 ? slidesToShow - 1 : 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: slidesToShow - 2 > 0 ? slidesToShow - 2 : 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: slidesToShow - 3 > 0 ? slidesToShow - 3 : 1,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: `${PREV_NEXT_WIDTH_PERCENTAGE}%`,
            },
          },
        ],
      }));
    }
  }, [itemsCount, maxSlides, setSettings]);

  return settings;
};

export default useSettings;
